import type { SlotValue } from '~/pages/ProcurementPlanDetail/models/calc'

/**
 * 需要計画値に未入力（空）コマが 1 つ以上あるか判定する (AC-PLC-028)。
 * 0（明示的なゼロ）は正常値としてブロックしない。
 *
 * 調達/販売内訳は検査しない: rowToSlots が未設定コマを 0 に正規化しており、
 * 内訳の None は「取引なし = 0 kWh」を意味する正常値であるため。
 * 未入力＝元データ欠落は需要想定側のみで発生する。
 */
export function hasEmptySlots(demandSlots: SlotValue[]): boolean {
  return demandSlots.some((v) => v === undefined)
}
